import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Schematic } from 'app/classes/schematic/schematic';

@Component({
  selector: 'app-schematics-card',
  templateUrl: './schematics-card.component.html',
  styleUrls: ['./schematics-card.component.css'],
  standalone: false
})
export class SchematicsCardComponent implements OnInit, OnDestroy {

  _schematic: Schematic;
  @Input()
  public set schematic(v: Schematic) {
    this._schematic = v;

    if (v) {
      this.tree = [this._schematic.getTreeNode()];
    } else {
      this.tree = [];
    }
  }

  public get schematic(): Schematic {
    return this._schematic;
  }

  selectedNodes: any[];

  selectedNode: any;

  tree: any[];

  constructor() {
  }

  ngOnInit(): void {
    this.getLocal();
  }

  saveLocal() {

    const ids = [];
    const processTree = (treeNodes: any[]) => treeNodes.forEach(treeNode => {

      if (treeNode.expanded) {
        ids.push(treeNode.data);
      }

      if (treeNode.children != null) processTree(treeNode.children);
    });

    processTree(this.tree);

    localStorage.setItem(`schematics-card:${this.schematic.id}`, JSON.stringify(ids));
  }

  getLocal() {
    const idsString = localStorage.getItem(`schematics-card:${this.schematic.id}`);

    if (idsString) {
      const ids: string[] = JSON.parse(idsString);
      const processTree = (treeNodes: any[]) => treeNodes.forEach(treeNode => {

        treeNode.expanded = ids.includes(treeNode.data);

        if (treeNode.children != null) processTree(treeNode.children);
      });

      processTree(this.tree);
    }
  }

  nodeSelect(nodeEvent: any) {
    console.log(nodeEvent);
    this.selectedNode = nodeEvent.node;
  }

  nodeUnselect(nodeEvent: any) {
    console.log(nodeEvent);
  }

  onNodeExpand(node: any) {
    console.log(node);
    this.saveLocal();

  }

  onNodeCollapse(node: any) {
    console.log(node);
    this.saveLocal();
  }

  ngOnDestroy(): void {
    this.saveLocal();
  }
}
